<template>
  <div class="page-acute-rhinitis">
    <!-- Begin head block -->
    <section class="head-block">
      <div class="container">
        <div class="head-block__bg">
          <img src="~@/assets/img/acute-rhinitis/banner-bg.jpg" alt="" />
        </div>
        <div class="row">
          <div class="col-x-lg-7 col-lg-7 col-md-7 col-xs-12">
            <h1
              class="head-block__title"
              v-html="$t('acuteRhinitis.title')"
            ></h1>
            <p class="head-block__text" v-html="$t('acuteRhinitis.text')"></p>
            <div class="block-list">
              <div
                class="block-list__title"
                v-html="$t('acuteRhinitis.blockList.title')"
              ></div>
              <div class="block-list__row">
                <div
                  class="block-list__col"
                  v-for="(item, key) in $t('acuteRhinitis.blockList.items')"
                  :key="key"
                >
                  <div class="block-list__item">
                    <div class="block-list__item-number">{{ key + 1 }}</div>
                    <div class="block-list__item-text" v-html="item.text"></div>
                  </div>
                </div>
              </div>
              <p
                class="block-list__text"
                v-html="$t('acuteRhinitis.blockList.text')"
              ></p>
            </div>
          </div>
        </div>
        <div class="icons-list">
          <div
            class="icons-list__title"
            v-html="$t('acuteRhinitis.iconsList.title')"
          ></div>
          <div class="icons-list__row">
            <div
              class="icons-list__col"
              v-for="(item, key) in $t('acuteRhinitis.iconsList.items')"
              :key="key"
            >
              <div
                :class="`icons-list__item icons-list__item--${key + 1}`"
                v-html="item.title"
              ></div>
            </div>
          </div>
          <router-link
            @click.native="rinit1MainBtn()"
            :to="$t('acuteRhinitis.iconsList.button.link')"
            class="icons-list__btn"
          >
            {{ $t("acuteRhinitis.iconsList.button.title") }}
          </router-link>
        </div>
      </div>
    </section>
    <!-- // -->
    <!-- Begin bibliography -->
    <section class="bibliography">
      <div class="container">
        <div class="bibliography__info">
          <p v-html="$t('bibliography.info_1')"></p>
        </div>
        <div class="bibliography__list">
          <h3
            class="bibliography__list-title"
            v-html="$t('bibliography.bibliographyTitle')"
          ></h3>
          <div
            class="bibliography__list-item"
            v-for="(item, key) in $t('acuteRhinitis.bibliography.list')"
            :key="key"
          >
            <div class="bibliography__list-number">{{ key + 1 }}.</div>
            <div class="bibliography__list-text" v-html="item"></div>
          </div>
        </div>
      </div>
    </section>
    <!-- // -->
  </div>
</template>

<script>
export default {
  name: "AcuteRhinitisView",
  metaInfo() {
    if (this.$i18n.locale === "ua") {
      return {
        title: "Називін® Сенситив та гострий риніт🤧 Симптоми і профілактика",
        meta: [
          {
            name: "description",
            content:
              "При гострому риніті головний біль 🤯, поява 👃💦 виділень, посилення закладеності носа🤒 та зміна голосу 🤧. Профілактика: 🥗 🏋‍♀ 🚭 🌡 🧹"
          },
          {
            property: "og:description",
            content:
              "Називін® Сенситив та гострий риніт🤧 Симптоми і профілактика"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    } else if (this.$i18n.locale === "ru") {
      return {
        title: "Називин® Сенситив и острый ринит 🤧 Симптомы и профилактика",
        meta: [
          {
            name: "description",
            content:
              "При остром рините головная боль 🤯, появление 👃💦 выделений, усиление заложенности носа🤒 и изменение голоса 🤧. Профилактика: 🥗 🏋♀ 🚭 🌡 🧹"
          },
          {
            property: "og:description",
            content:
              "Називин® Сенситив и острый ринит 🤧 Симптомы и профилактика"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    }
  },
  methods: {
    insertAfter(newNode, existingNode) {
      existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
    },
    responsive() {
      if (window.innerWidth <= 991) {
        var bannerImage = document.querySelector(".head-block__bg");
        var bannerTitle = document.querySelector(".head-block__title");
        this.insertAfter(bannerImage, bannerTitle);
      }
    },
    rinit1MainBtn() {
      // eslint-disable-next-line no-undef
      gtag("event", "click", { event_category: "rinit_1_main_btn" });
    }
  },
  mounted() {
    this.responsive();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto"
    });
  }
};
</script>
<style lang="scss">
@import "@/assets/scss/views/_acute-rhinitis";
</style>
